/* eslint-disable no-param-reassign */
import axios from 'ggApp/utils/requests';
import ggForm from 'ggApp/modules/form';

const { serverValidation } = ggForm.validations;

export function getAddressByUser() {
    return (dispatch) =>
        dispatch({
            type: 'GET_ADDRESS_BY_USER',
            promise: axios.get(`/addresses`).then((res) => res.data.addresses),
        });
}

export function setActiveAddress(addressId, addressType) {
    return {
        type: 'SET_ACTIVE_ADDRESS',
        addressId,
        addressType,
    };
}

export function add(address) {
    return (dispatch) => {
        delete address.phone;

        if (address.zipcode) {
            address.zipcode = address.zipcode.trim();
        }

        return axios
            .post(`/addresses`, { address })
            .then((res) => {
                dispatch({
                    type: 'ADD_ADDRESS_SUCCESS',
                    data: res.data.addresses,
                });

                return res.data.addresses;
            })
            .catch(serverValidation);
    };
}

export function edit(id, address) {
    return (dispatch) => {
        if (address.zipcode) {
            address.zipcode = address.zipcode.trim();
        }

        return axios
            .patch(`/addresses/${id}`, { address })
            .then((res) => {
                dispatch({
                    type: 'EDIT_ADDRESS_SUCCESS',
                    data: res.data.addresses,
                });

                return res.data.addresses;
            })
            .catch(serverValidation);
    };
}
